import './startup.js'

import {createApp} from 'vue'
import {createPinia} from 'pinia'

import '@/styles/app.scss'
import App from './App.vue'
import i18n from '@/i18n'
import router from '@/router'

import langRouter from '@/extensions/langRouter'
import reveal from '@/extensions/reveal'

import {Vue3Mq} from 'vue3-mq'
import {createGtag} from 'vue-gtag'
import mitt from 'mitt'

import {
    useActionStore,
    useActualityStore,
    useAlertStore,
    useAuthStore,
    useCategoryStore,
    useDeleteNotificationStore,
    useDocumentStore,
    useEmployeeStore,
    useEventStore,
    useNoticeStore,
    usePopupStore,
    useUserStore
} from '@/store'
import {QUERY, ROUTES} from '@/config'

/* --- EXTENSIONS --- */
const app = createApp(App)
    .use(createPinia())
    .use(i18n)
    .use(router)
    .use(langRouter, 'fr')
    .use(reveal)
    .use(Vue3Mq, {
        breakpoints: {
            xs: 0,
            sm: 566,
            md: 1024,
            lg: 1360,
            xl: 1440
        }
    })

app.config.globalProperties.$auth = useAuthStore()
app.config.globalProperties.$actuality = useActualityStore()
app.config.globalProperties.$action = useActionStore()
app.config.globalProperties.$alert = useAlertStore()
app.config.globalProperties.$category = useCategoryStore()
app.config.globalProperties.$document = useDocumentStore()
app.config.globalProperties.$notification = useDeleteNotificationStore()
app.config.globalProperties.$employee = useEmployeeStore()
app.config.globalProperties.$event = useEventStore()
app.config.globalProperties.$notice = useNoticeStore()
app.config.globalProperties.$popup = usePopupStore()
app.config.globalProperties.$user = useUserStore()

app.config.globalProperties.$query = QUERY
app.config.globalProperties.$routes = ROUTES

/* --- EVENT BUS --- */
const emitter = mitt()
app.provide('emitter', emitter)

/* --- GOOGLE ANALYTICS --- */
app.use(createGtag({
    initMode: 'manual',
    tagId: import.meta.env.VITE_APP_GTAG_ID,
    pageTracker: {router}
}))


/* --- GOOGLE RECAPTCHA ---
import {VueReCaptcha} from "vue-recaptcha-v3";
app.use(VueReCaptcha, { siteKey: import.meta.env.VITE_APP_RECAPTCHA_KEY })
*/

/* --- MOUNT --- */
app.mount('#app')
